<template>
  <div class="class">
    <teacherNav
      :current="current"
      @info-event="myInfoEvent"
      @public-event="publicEvent"
    ></teacherNav>
    <div class="class_cont bg_blue">
      <div class="class_div radius8 bs bg_white">
        <div class="class_title flex">
          <p class="f30px cl_dark">学校资源库·课件</p>
        </div>
        <div class="task_cont_nav f18px cl_dark paper_my_nav">
          <div
            class="task_cont_nav_list cur"
            :class="{ on: nav_cur == 1 }"
            @click="navCheck(1)"
          >
            我的课件
          </div>
          <div
            class="task_cont_nav_list cur"
            :class="{ on: nav_cur == 2 }"
            @click="navCheck(2)"
          >
            公共课件
          </div>
          <router-link
            to="/courseware_upload"
            class="paper_my_nav_btn tc cl_white cur"
            @click="dialog_show = true"
            >上传课件</router-link
          >
        </div>
        <div class="task_subject cl_gray tc">
          <span
            class="task_subject_list bg_gray cur"
            v-for="(item, index) in subject"
            :key="index"
            @click="subjectCheck(item.subjectId)"
            :class="{ on: subject_cur == item.subjectId }"
            >{{ item.subjectName }}</span
          >
        </div>
        <div class="task_video">
          <div class="task_video_l">
            <div class="famous_screen_list">
              <el-select
                v-model="material_cur"
                placeholder="全部"
                @change="materialSelect"
              >
                <el-option
                  v-for="item in material"
                  :key="item.Id"
                  :label="item.Name"
                  :value="item.Id"
                ></el-option>
              </el-select>
            </div>
            <div
              class="task_video_nav radius8 mat20 cl_dark"
              v-if="chapter.length > 0"
            >
              <div
                class="task_nav_first mab20"
                v-for="(item, index) in chapter"
                :key="index"
              >
                <div
                  class="task_nav_first_title f16px cur"
                  @click="firstOpen(index)"
                  :class="{ on: item.open }"
                >
                  <img src="../../../static/select_right.png" class="mar5" />
                  <span>{{ item.gradeName }}</span>
                </div>
                <div
                  class="task_nav_second mat10"
                  v-for="(second, secondIndex) in item.chapter_data"
                  :key="secondIndex"
                  v-if="item.open"
                >
                  <div
                    class="task_nav_second_title cur"
                    @click="secondOpen(index, secondIndex)"
                    :class="{ on: second.open }"
                    :title="second.chapter"
                  >
                    <img src="../../../static/select_right.png" class="mar5" />
                    <span class="clip">{{ second.chapter }}</span>
                  </div>
                  <div class="task_nav_three" v-if="second.open">
                    <div
                      class="task_nav_three_title clip mat10 cur"
                      v-for="(three, index) in second.section_knowledge_data"
                      :key="index"
                      :class="{ on: three.knowledgeId == chapter_cur }"
                      @click="knowledgeCheck(three.knowledgeId)"
                      :title="three.knowledgeName"
                    >
                      {{ three.knowledgeName }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="task_video_r"
            v-if="chapter_cur != '' && chapter_cur != null"
          >
            <div class="task_paper_screen mat30">
              <div class="test_screen cl_gray">
                <div class="test_screen_l f16px">
                  <span class="inline">使用年级</span><i class="inline">：</i>
                </div>
                <div class="test_screen_r tc">
                  <span
                    class="test_screen_list bg_gray"
                    v-for="(item, index) in grade"
                    :key="index"
                    :class="{ on: item.gradeId == grade_cur }"
                    @click="gradeCheck(item.gradeId)"
                    >{{ item.gradeName }}</span
                  >
                </div>
              </div>
            </div>
            <div class="f18px cl_gray mat30">
              共 <span class="cl_yel">{{ total }}</span> 个课件
            </div>
            <div
              class="flex paper_library_list_cont mat30"
              v-if="list.length > 0"
            >
              <div
                class="video_library_list flex"
                v-for="(item, index) in list"
                :key="index"
              >
                <div class="video_library_list_l">
                  <div
          
                    class="f18px clip"
                    >{{ item.name }}</div
                  >
                  <p class="cl_gray clip mat10">{{ item.intro }}</p>
                  <p class="cl_dark mat20">上传者：{{ item.user_name }}</p>
                </div>
                <div class="video_library_list_r flex">
                  <div
                    class="cl_violet paper_library_list_edit mar10 cur"
                    @click="download(item.id)"
                  >
                    下载
                  </div>
                  <div
                    v-if="nav_cur == 1"
                    class="flex paper_library_list_delete cl_red mal10 cur"
                    @click="remove(item.id)"
                  >
                    <img src="../../../static/delete_red.png" class="mar10" />
                    <p>删除</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="famous_page flex" v-if="list.length > 0">
              <div class="famous_page_l f16px cl_gray"></div>
              <div class="famous_page_r cl_dark">
                <el-pagination
                  background
                  layout="prev, pager, next, jumper"
                  @current-change="handleCurrentChange"
                  :page-size="pageSize"
                  :current-page="currentPage"
                  :total="total"
                ></el-pagination>
              </div>
            </div>
            <div class="choice_empty tc f18px cl_gray" v-if="list.length == 0">
              <img src="../../../static/paper_empty.png" /><br />
              <router-link
                to="/video_upload"
                class="mat20 f18px cl_violet inline cur paper_my_empty_btn"
                >立刻上传</router-link
              >
            </div>
          </div>
          <div class="task_video_r" v-else>
            <div class="choice_empty tc f18px cl_gray" v-if="list.length == 0">
              <p>请先选择章节列表。</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 编辑视频 -->
    <el-dialog title="编辑视频" :visible.sync="edit_show" width="60%" center>
      <div class="f16px video_dialog_cont">
        <div class="video_upload_item">
          <div class="video_upload_item_l f16px cl_dark mat10">
            <span class="cl_red">*</span>视频名称
          </div>
          <div class="video_upload_item_r">
            <input
              type="text"
              placeholder="请输入视频名称"
              v-model="name"
              class="f16px video_upload_item_input"
            />
          </div>
        </div>
        <div class="video_upload_item">
          <div class="video_upload_item_l f16px cl_dark mat5">
            <span class="cl_red">*</span>简介
          </div>
          <div class="video_upload_item_r">
            <textarea
              placeholder="请输入相关简介"
              v-model="intro"
              class="f16px video_upload_item_area"
            ></textarea>
          </div>
        </div>
        <div class="video_upload_item">
          <div class="video_upload_item_l f16px cl_dark mat5">
            <span class="cl_red">*</span>所属学科
          </div>
          <div class="video_upload_item_r">
            <div class="test_screen_r tc">
              <span
                class="test_screen_list bg_gray cl_gray"
                v-for="(item, index) in subject"
                :key="index"
                :class="{ on: item.subjectId == subject_cur_two }"
                @click="subjectCheckTwo(item.subjectId)"
                >{{ item.subjectName }}</span
              >
            </div>
          </div>
        </div>
        <div class="video_upload_item">
          <div class="video_upload_item_l f16px cl_dark mat5">
            <span class="cl_red">*</span>适用年级
          </div>
          <div class="video_upload_item_r">
            <div class="test_screen_r tc">
              <span
                class="test_screen_list bg_gray cl_gray"
                v-for="(item, index) in grade_two"
                :key="index"
                :class="{ on: item.gradeId == grade_cur_two }"
                @click="gradeCheckTwo(item.gradeId)"
                >{{ item.gradeName }}</span
              >
            </div>
          </div>
        </div>
        <div class="video_upload_item">
          <div class="video_upload_item_l f16px cl_dark mat10">
            <span class="cl_red">*</span>关联知识点
          </div>
          <div class="video_upload_item_r">
            <div class="video_upload_item_kn">
              <input
                type="text"
                placeholder="请选择知识点"
                v-model="knowledge_basic_name"
                class="f16px video_upload_item_input"
                disabled
              />
              <button class="f18px cl_violet" @click="knowledge_show = true">
                选择知识点
              </button>
            </div>
          </div>
        </div>
        <div class="video_upload_item">
          <div class="video_upload_item_l f16px cl_dark">
            <span class="cl_red">*</span>可见范围
          </div>
          <div class="video_upload_item_r">
            <label class="f18px cl_gray mar15">
              <input
                type="radio"
                v-model="who_can_see"
                value="self"
                class="mar10"
              />
              <span>仅自己可见</span>
            </label>
            <label class="f18px cl_gray mal15">
              <input
                type="radio"
                v-model="who_can_see"
                value="all"
                class="mar10"
              />
              <span>全校可见</span>
            </label>
          </div>
        </div>
      </div>
      <div slot="footer" class="f18px mab20">
        <span
          @click="edit_show = false"
          class="cl_violet cur inline paper_dialog_cancel"
          >取 消</span
        >
        <span
          @click.stop="editSubmit"
          class="cl_white cur inline paper_dialog_confirm"
          >确 定</span
        >
      </div>
    </el-dialog>
    <!-- 选择知识点 -->
    <el-dialog
      title="选择关联知识点"
      :visible.sync="knowledge_show"
      width="40%"
      center
    >
      <div class="f16px video_dialog">
        <div class="famous_screen_list">
          <el-select
            v-model="material_cur_two"
            placeholder="全部"
            @change="materialSelectTwo"
          >
            <el-option
              v-for="item in material_two"
              :key="item.Id"
              :label="item.Name"
              :value="item.Id"
            ></el-option>
          </el-select>
        </div>
        <div
          class="task_video_nav radius8 mat20 cl_dark"
          v-if="chapter_two.length > 0"
        >
          <div
            class="task_nav_first mab20"
            v-for="(item, index) in chapter_two"
            :key="index"
          >
            <div
              class="task_nav_first_title f16px cur"
              @click="firstOpenTwo(index)"
              :class="{ on: item.open }"
            >
              <img src="../../../static/select_right.png" class="mar5" />
              <span>{{ item.gradeName }}</span>
            </div>
            <div
              class="task_nav_second mat10"
              v-for="(second, secondIndex) in item.chapter_data"
              :key="secondIndex"
              v-if="item.open"
            >
              <div
                class="task_nav_second_title cur"
                @click="secondOpenTwo(index, secondIndex)"
                :class="{ on: second.open }"
              >
                <img src="../../../static/select_right.png" class="mar5" />
                <span class="clip">{{ second.chapter }}</span>
              </div>
              <div class="task_nav_three" v-if="second.open">
                <div
                  class="task_nav_three_title clip mat10 cur"
                  v-for="(three, index) in second.section_knowledge_data"
                  :key="index"
                  :class="{ on: three.knowledgeId == knowledge_basic_id }"
                  @click="
                    knowledgeCheckTwo(three.knowledgeId, three.knowledgeName)
                  "
                >
                  {{ three.unit }} {{ three.knowledgeName }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import teacherNav from "../../components/teacher_nav.vue";

export default {
  name: "class_manage",
  components: {
    teacherNav,
  },
  props: {},
  data() {
    return {
      myInfo: {},
      public: {},
      current: {
        navCur: 6,
        listCur: 3,
        open: 0,
      },
      nav_cur: 1,
      subject: [], //学科
      subject_cur: {},
      grade: [], //年级
      grade_cur: "",
      list: [],
      currentPage: 1, //当前页数
      pageSize: 20, //每页数量
      total: 0, //总页数
      material: [], //教材
      material_cur: "",
      chapter: [], //章节
      chapter_cur: "",
      //编辑
      edit_id: "",
      edit_show: false,
      knowledge_show: false,
      name: "", //名称
      intro: "", //简介
      who_can_see: "all", //可见范围；all所有人self自己
      material_two: [], //教材
      material_cur_two: "",
      chapter_two: [], //章节
      chapter_cur_two: "",
      subject_cur_two: "",
      grade_two: [],
      grade_cur_two: "",
      knowledge_basic_id: "",
      knowledge_basic_name: "",
    };
  },
  created() {},
  mounted() {
    this.getSubject();
    this.getGrade();
  },
  methods: {
    myInfoEvent(data) {
      this.myInfo = data;
    },
    publicEvent(data) {
      this.public = data;
    },
    navCheck(e) {
      this.nav_cur = e;
      this.currentPage = 1;
      this.getSubject();
    },
    //学科
    getSubject() {
      this.$get("/api/material/get_subject_data", {}).then((res) => {
        this.subject = res.data;
        this.subject_cur = this.subject[0].subjectId;
        this.subject_cur_two = this.subject[0].subjectId;
        this.getMaterial();
      });
    },
    subjectCheck(e) {
      this.subject_cur = e;
      this.currentPage = 1;
      this.getMaterial();
    },
    //年级
    getGrade() {
      this.$get("/api/teacher/get_school_grade_data", {
        token: localStorage.getItem("token"),
      }).then((res) => {
        this.grade_two = [].concat(res.data);
        this.grade_cur_two = this.grade_two[0].gradeId;
        this.grade = res.data;
        this.grade.unshift({ gradeId: "", gradeName: "全部" });
        this.grade_cur = this.grade[0].gradeId;
      });
    },
    gradeCheck(e) {
      this.grade_cur = e;
      this.currentPage = 1;
      this.getList();
    },
    //教材
    getMaterial() {
      this.$get("/api/teacher/get_subject_chapter_edition_data", {
        token: localStorage.getItem("token"),
        subject_id: this.subject_cur,
      }).then((res) => {
        this.material_two = [].concat(res.data);
        this.material_cur_two = this.material_two[0].Id;
        this.material = res.data;
        this.material_cur = this.material[0].Id;
        this.getChapter();
      });
    },
    materialSelect(e) {
      this.currentPage = 1;
      this.getChapter();
    },
    //章节
    getChapter() {
      this.$get("/api/teacher/get_chapter_data", {
        token: localStorage.getItem("token"),
        subject_id: this.subject_cur,
        edition_id: this.material_cur,
      }).then((res) => {
        this.chapter = [];
        this.chapter_cur = "";
        if (res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            res.data[i].open = false;
            if (res.data[i].chapter_data.length > 0) {
              for (let j = 0; j < res.data[i].chapter_data.length; j++) {
                res.data[i].chapter_data[j].open = false;
              }
            }
          }
          this.chapter = res.data;
          res.data[0].open = true;
          if (res.data[0].chapter_data.length > 0) {
            res.data[0].chapter_data[0].open = true;
            if (
              this.chapter[0].chapter_data[0].section_knowledge_data.length > 0
            ) {
              this.chapter_cur =
                this.chapter[0].chapter_data[0].section_knowledge_data[0].knowledgeId;
            }
          }
          if (this.chapter_cur != "") {
            this.getList();
          }
        }
      });
    },
    firstOpen(e) {
      if (this.chapter[e].open) {
        this.chapter[e].open = false;
      } else {
        this.chapter[e].open = true;
      }
    },
    secondOpen(index, secondIndex) {
      if (this.chapter[index].chapter_data[secondIndex].open) {
        this.chapter[index].chapter_data[secondIndex].open = false;
      } else {
        this.chapter[index].chapter_data[secondIndex].open = true;
      }
    },
    knowledgeCheck(id) {
      this.chapter_cur = id;
      this.getList();
    },
    //视频
    getList() {
      this.$get("/api/teacher/get_examination_courseware_list", {
        token: localStorage.getItem("token"),
        subject_id: this.subject_cur,
        grade_id: this.grade_cur,
        knowledge_basic_id: this.chapter_cur,
        type: this.nav_cur,
        page: this.currentPage,
        limit: this.pageSize,
      }).then((res) => {
        this.list = res.data.data;
        this.total = res.data.total;
      });
    },
    handleCurrentChange: function (currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //删除
    remove(e) {
      this.$messageBox
        .confirm("确定删除？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        })
        .then(() => {
          this.$get("/api/teacher/post_examination_courseware_del", {
            token: localStorage.getItem("token"),
            id: e,
          }).then((res) => {
            this.$message({
              type: "success",
              message: res.msg,
              duration: 1500,
            });
            setTimeout(() => {
              this.getList();
            }, 1500);
          });
        })
        .catch(() => {});
    },
    //编辑
    edit(index) {
      this.edit_show = true;
      this.edit_id = this.list[index].id;
      this.name = this.list[index].name;
      this.intro = this.list[index].intro;
      this.grade_cur_two = this.list[index].grade_id_str;
      this.subject_cur_two = this.list[index].subject_id;
      this.knowledge_basic_id = this.list[index].knowledge_basic_id;
      this.knowledge_basic_name = this.list[index].knowledge_basic_name;
      this.who_can_see = this.list[index].who_can_see;
    },
    gradeCheckTwo(e) {
      this.grade_cur_two = e;
    },
    subjectCheckTwo(e) {
      this.subject_cur_two = e;
    },
    materialSelectTwo(e) {
      this.currentPage = 1;
      this.getChapterTwo();
    },
    //章节
    getChapterTwo() {
      this.$get("/api/teacher/get_chapter_data", {
        token: localStorage.getItem("token"),
        subject_id: this.subject_cur_two,
        edition_id: this.material_cur_two,
      }).then((res) => {
        this.chapter_two = [];
        this.chapter_cur_two = "";
        if (res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            res.data[i].open = false;
            if (res.data[i].chapter_data.length > 0) {
              for (let j = 0; j < res.data[i].chapter_data.length; j++) {
                res.data[i].chapter_data[j].open = false;
              }
            }
          }
          this.chapter_two = res.data;
        }
      });
    },
    firstOpenTwo(e) {
      if (this.chapter_two[e].open) {
        this.chapter_two[e].open = false;
      } else {
        this.chapter_two[e].open = true;
      }
    },
    secondOpenTwo(index, secondIndex) {
      if (this.chapter_two[index].chapter_data[secondIndex].open) {
        this.chapter_two[index].chapter_data[secondIndex].open = false;
      } else {
        this.chapter_two[index].chapter_data[secondIndex].open = true;
      }
    },
    knowledgeCheckTwo(id, name) {
      this.knowledge_basic_id = id;
      this.knowledge_basic_name = name;
      this.knowledge_show = false;
    },
    editSubmit() {
      this.$get("/api/teacher/post_examination_video_edit", {
        token: localStorage.getItem("token"),
        id: this.edit_id,
        name: this.name,
        intro: this.intro,
        grade_id_str: this.grade_cur_two,
        subject_id: this.subject_cur_two,
        knowledge_basic_id: this.knowledge_basic_id,
        who_can_see: this.who_can_see,
      }).then((res) => {
        this.$message({
          duration: 1500,
          message: res.msg,
          type: "success",
        });
        this.edit_show = false;
        this.getList();
      });
    },
    //下载
    download(id) {
      this.$get("/api/teacher/post_examination_courseware_download", {
        token: localStorage.getItem("token"),
        id: id,
      }).then((res) => {
        console.log(res);
        if (res&&res.data&&res.data.url) {
            this.downloadFile(res.data.url,)
        }
      });
    },
    downloadFile(url, filename) {
      if (!url) return;
      let link = document.createElement("a"); //创建a标签
      link.style.display = "none";
      link.href = url; //文件下载地址
    //   link.setAttribute("download", filename); //设置下载属性 以及文件名
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
  },
};
</script>

<style>
</style>
